import React from 'react';
import './NotFound.css'

const NotFound = () => {
  return (
    <div className='notFound mt-5'>
      <h1 className='text-white'><span className='text-danger'>404</span>, Not Founded</h1>
    </div>
  );
};

export default NotFound;